import PropTypes from 'prop-types';

import TextField from '@gef-ui/form-material/TextField';

// MUI Textfield only for output - surpresses hover and focus styles
export const OutputFormTextField = ({ slotProps, ...rest }) => (
	<TextField
		sx={{
			'&:hover fieldset': {
				borderColor: 'lightgrey !important',
			},
			'& .MuiOutlinedInput-root': {
				'&.Mui-focused fieldset': {
					border: '0.5px solid lightgrey',
				},
			},
		}}
		slotProps={{
			input: {
				readOnly: true,
			},
			...slotProps,
		}}
		{...rest}
	/>
);

OutputFormTextField.propTypes = {
	slotProps: PropTypes.object,
};

export default OutputFormTextField;
